var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.showNullHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.nullHtml)}}):_c('div',[(_vm.noRouter)?_c('a',{attrs:{"href":_vm.url}},[_vm._v("\n      "+_vm._s(_vm.source)+"\n    ")]):_c('router-link',{attrs:{"to":_vm.url}},[_vm._v("\n      "+_vm._s(_vm.source)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }